import { Fragment } from "react";
import { Container } from "@/components/container";
import { PageNavbar } from "@/pages/account";

import { AccountUserProfileContent } from ".";

const AccountUserProfilePage = () => {

  return (
    <Fragment>
      <PageNavbar />

      <Container>
        <AccountUserProfileContent />
      </Container>
    </Fragment>
  );
};

export { AccountUserProfilePage };
